Pixlee.module('Behaviors', function(Behaviors, App, Backbone, Marionette, $) {

    Behaviors.AppendUploaderTiles = Marionette.Behavior.extend({
        ui: {
            uploaderTile: '.uploader_tile'
        },
        events: {
            'click @ui.uploaderTile': 'clickUploaderTile',
            'keydown @ui.uploaderTile': 'clickUploaderTile'
        },
        collectionEvents: {
            'sync': 'onSync'
        },
        clickUploaderTile: function(ev) {
            // Keycode 13 = Enter Key
            if (ev.type === 'keydown' && ev.keyCode !== 13) {
                return;
            }
            var data = {
                name: 'pixlee:show:uploader',
                type: 'action',
                source: 'widget',
                destination: 'parent',
                data: {
                    widgetId: window.location.href,
                    // For accessiblity purposes: tracking whether user is using keyboard/mouse
                    // Used to keep track of using-keyboard or using-mouse for uploader
                    usingKeyboard: ev.type === 'keydown'
                }
            };

            window.lastElement = ev.target;
            window.parent.postMessage(JSON.stringify(data), '*');
        },
        onSync: function(collection, response) {
            if (_.isFalsy(response)) {
                return;
            }
            var _this = this;
            var widgetType = gon.type;
            var displayOptions = this.view.options.displayOptions;
            var headerOptions = displayOptions.headerOptions;
            var headerLayout = headerOptions.layout;
            var headerTiles = headerOptions.end_tile_upload_button_background_showHide;
            var numUploaderTiles = 1;
            var hideIfLessThanSet = !_.isFalsy(App.displayOptions.get('hideIfLessThan')) || !_.isFalsy(gon.current_account.extra_fields.hideIfLessThan);
            var $widgetView = $('#frame');
            var $clearFix = $('ul.clearfix');
            var $clearfixChildren = $clearFix.children();
            var $photoBlock = $('.photo_block:visible');

            var singlePhotoSize = 0;
            var filledGallerySpace = 0;
            var availableGallerySpace = 0;

            var msg = {
                name: 'pixlee:widget:num:photos',
                type: 'action',
                source: 'widget',
                destination: 'parent',
                data: {
                    photoCount: _this.view.collection ? _this.view.collection.length : 0
                }
            };
            window.top.postMessage(JSON.stringify(msg), '*');

            // check if there's not enough photos according to this specific display option's rules
            var photoCount = _this.view.collection.length;
            var enoughPhotos;
            var imageLimit;

            if (hideIfLessThanSet) {
                imageLimit = !_.isFalsy(App.displayOptions.get('hideIfLessThan')) ? App.displayOptions.get('hideIfLessThan') : gon.current_account.extra_fields.hideIfLessThan;
            }

            if (widgetType === 'carousel') {
                // a carousel widget includes uploader tiles as part of the collection
                // so this variable returns a new collection minus the uploader tiles
                var collectionWithoutTiles = _this.view.collection.reject(function(model) {
                    return model.get('isUploaderTile');
                });

                // widgets can have a max of 2 uploader tiles; front and/or end
                photoCount = collectionWithoutTiles.length;
            }

            enoughPhotos = imageLimit !== undefined ? photoCount >= imageLimit : photoCount;

            // DO NOT SHOW THE LOGO IF:
            // remove powered by is toggled
            // (I believe underscore's indexOf is polyfilled unlike Array.prototype.indexOf)
            var removePoweredBy = _.indexOf(App.currentUser.get('features'), 'remove_powered_by') !== -1;

            // hideIfLessThan is set and there's not enough photos
            var notEnoughPhotos = !enoughPhotos && hideIfLessThanSet;

            // there are zero photos and tiles aren't set
            var emptyAlbum = !enoughPhotos && _.isFalsy(headerTiles);

            // OTHERWISE SHOW THE LOGO
            if (!(removePoweredBy || notEnoughPhotos || emptyAlbum)) {
                //let the parent frame know it's cool to render the logo
                msg = {
                    name: 'pixlee:generate:attribution:link',
                    type: 'action',
                    source: 'widget',
                    destination: 'parent',
                    data: {
                        src: window.location.href,
                        locale: window.I18n.locale,
                        isSimple: gon.current_album.album_type === 'standard' || gon.current_album.album_type === 'story' || gon.current_album.album_type === 'influencer_campaign' || gon.current_album.album_type === 'posts',
                        landingPageURL: gon.current_account.extra_fields.landing_page_url,
                        disablePoweredByClick: App.displayOptions.get('disablePoweredByClick')
                    }
                };

                window.parent.postMessage(JSON.stringify(msg), '*');
            }

            //special case for tiles with a header
            if (!(hideIfLessThanSet && !enoughPhotos || !enoughPhotos && _.isFalsy(headerTiles))) {
                $('#header_wrapper').css('visibility', 'visible');
            }

            //calculate how much space is empty in the gallery
            if ($photoBlock.length) {
                singlePhotoSize = $photoBlock.width();
                filledGallerySpace = $photoBlock.length * singlePhotoSize;
                availableGallerySpace = $widgetView.width() - filledGallerySpace;
            }

            if (widgetType === 'vertical' || widgetType === 'coverflow' || widgetType === 'horizontal') {
                //if there's enough room to fit at least one photo, try to fit as many as possible. otherwise just add 1
                if (availableGallerySpace > singlePhotoSize) {
                    // set this display option to limit the number of uploader tiles i a small album's widget
                    if (_.isFalsy(displayOptions.num_uploader_tiles)) {
                        //add just enough tiles to fill up the gallery
                        numUploaderTiles = Math.floor(availableGallerySpace / singlePhotoSize);
                    } else {
                        numUploaderTiles = displayOptions.num_uploader_tiles;
                    }

                }
            }

            // Remove all uploader tiles before the collection if collection exists (for interactive social hub)
            var $targetChildren = (headerLayout === 'tile') ? $clearfixChildren.slice(1) : $clearfixChildren;
            if (widgetType !== 'carousel' && this.view.collection.length && $targetChildren.first().hasClass('uploader_tile')) {
                $.each($targetChildren, function(i, tile) {
                    if ($(tile).hasClass('uploader_tile')) {
                        tile.remove();
                    } else {
                        return false;
                    }
                });
            }

            if (App.hasTOS && _.isTruthy(headerTiles)) {
                // Want to append uploader tiles if we are on the last page of photos
                // If no photos were returned in the first page
                if ((response.total > 0 && _.isFalsy(response.next)) || (response.total === 0 && response.page === 1)) {
                    // Carousel Widget end uploader tile handler
                    if (widgetType === 'carousel') {
                        var EndUploaderTileModel = new Backbone.Model({
                            isUploaderTile: true,
                            uploaderTileType: 'end'
                        });
                        if (_.isFalsy(this.view.collection.findWhere(EndUploaderTileModel.attributes))) {
                            this.view.collection.add(EndUploaderTileModel);
                            this.view.collection.trigger('sync');
                        }
                    } else {
                        this.view.$el.find('.uploader_tile').remove();
                        var uploaderTileHtml = require('../../apps/common/templates/v2/_end_uploader_tile.jst.ejs')({ widgetType: widgetType, hasTOS: App.hasTOS });

                        // append html from tile template
                        for (var i = 0; i < numUploaderTiles; i++) {
                            $clearFix.append(uploaderTileHtml);
                        }

                        // need to reload sly since a new list element (uploader tile) is appended to the list
                        if (this.view.sly) {
                            this.view.sly.reload({
                                silentScroll: true
                            });
                            // sometimes when the end upload tile is appended on
                            // the end it gets added to the dom but sly doesn't
                            // recognize it. it's in the DOM but not visible so
                            // you have to hit prev then next to see it.
                            // this tricks sly into making it visible.
                            var nextIsDisabled = $('.next').hasClass('disabled');
                            if (nextIsDisabled) {
                                this.view.sly.slideBy(-1, true);
                            }
                        }
                    }
                }
            }

            // Call the collectionViews onRender Method on the first page
            // Sync because sly won't be initialized properly if not
            if (response.page === 1 && _.isFalsy(response.next) && widgetType !== 'photowall' && widgetType !== 'mosaic_v2' && widgetType !== 'carousel') {
                this.view.onRender();
            }

            // Setup sly if it hasn't been set up yet
            // this is needed because onRender will only create sly properly if the colection has models in it
            // if there are no models, we still want the scrolling to behave like normal with all of the uploader tiles,
            // so we need to intialize it here
            if (_.isFalsy(this.view.sly) && widgetType !== 'photowall' && widgetType !== 'mosaic_v2' && widgetType !== 'carousel') {
                var frame = $('#frame');
                var LeftAlign = displayOptions.horizontalLayoutLeftAlign;
                var slyObj = { // initial object is for vertical type
                    horizontal: 0,
                    smart: 1,
                    activateMiddle: 1,
                    itemNav: LeftAlign ? 'basic' : 'centered',
                    activateOn: 'click',
                    mouseDragging: 0,
                    touchDragging: 1,
                    releaseSwing: 1,
                    startAt: 0,
                    scrollBy: 0,
                    speed: 300,
                    elasticBounds: 1,
                    easing: 'easeOutExpo',
                    prevPage: $('.prev'),
                    nextPage: $('.next')
                };

                if (widgetType === 'coverflow') {
                    slyObj.itemNav = 'forceCentered';
                    slyObj.horizontal = 1;
                    slyObj.easing = 'swing';
                } else if (widgetType === 'horizontal') {
                    slyObj.horizontal = 1;
                }

                this.sly = new Sly(frame, slyObj).init();
            }
        }
    });
});
